import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

class WebsiteDescription extends Component {
  render() {
    return (
      <section className="pwlp-about-section" id="about">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10" className="text-center">
              <h2 className="pwlp-about-section__title">What is PayWeek?</h2>
              <p className="pwlp-about-section__desc">
                PayWeek is a modern, cloud-based accounting and payroll platform
                powering payroll processing, financial reporting, and tax
                compliance for 10,000+ businesses globally.
              </p>
            </Col>
          </Row>

          <Row className="pwlp-about-grid">
            <Col lg="4" md="6" className="pwlp-about-grid__col">
              <div className="pwlp-about-card">
                <div className="pwlp-about-card__icon pwlp-about-card__icon--green">
                  ⓘ
                </div>
                <h3 className="pwlp-about-card__title">Cloud-Based Platform</h3>
                <p className="pwlp-about-card__text">
                  Access your financial data anywhere, anytime with our secure
                  cloud infrastructure.
                </p>
              </div>
            </Col>

            <Col lg="4" md="6" className="pwlp-about-grid__col">
              <div className="pwlp-about-card">
                <div className="pwlp-about-card__icon pwlp-about-card__icon--purple">
                  ≣
                </div>
                <h3 className="pwlp-about-card__title">Intelligence Engine</h3>
                <p className="pwlp-about-card__text">
                  From first transaction to strategic planning with automated
                  insights and analytics.
                </p>
              </div>
            </Col>

            <Col lg="4" md="12" className="pwlp-about-grid__col">
              <div className="pwlp-about-card">
                <div className="pwlp-about-card__icon pwlp-about-card__icon--blue">
                  ⌖
                </div>
                <h3 className="pwlp-about-card__title">Global Compliance</h3>
                <p className="pwlp-about-card__text">
                  Stay compliant across all jurisdictions with automated tax
                  filing and reporting.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg="8" className="pwlp-about-mission-col">
              <div className="pwlp-about-mission">
                <div className="pwlp-about-card__icon pwlp-about-card__icon--mint">
                  ⚡
                </div>
                <h3 className="pwlp-about-mission__title">Our Mission</h3>
                <p className="pwlp-about-mission__text">
                  We help businesses simplify payroll, bookkeeping, and
                  compliance with software that feels modern, fast, and reliable.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}

export default WebsiteDescription;



// import React, { Component } from "react";

// import { Container, Row, Col } from "reactstrap";

// class WebsiteDescription extends Component {
//   render() {
//     return (
//       <React.Fragment>
//         <section className="section bg-web-desc">
//           <div className="bg-overlay"></div> 
//           <Container>
//             <Row>
//               <Col lg="12" className="text-center">
//                 <h2 className="text-white">RUN PAYROLL & MANAGE BOOKS WITH EASE</h2>
//                 <p className="pt-3 home-desc mx-auto">
//                 Take the stress out of payroll and bookkeeping—simple, accurate, and built for businesses like yours.

// Stay compliant, track expenses, and process payroll effortlessly
//                 </p>
                
//               </Col>
//             </Row>
//           </Container>
//         </section>
//       </React.Fragment>
//     );
//   }
// }

// export default WebsiteDescription;
